// SearchBar.js
import React from "react";
import { Box, InputBase } from "@mui/material";
import { Search } from "@mui/icons-material";

const SearchBar = ({ searchTerm, setSearchTerm }) => {
    return (
        <Box sx={{ display: "flex", alignItems: "center", background: "#f0f0f0", borderRadius: 2, padding: "6px 10px", mt: 1 }}>
            <Search sx={{ color: "#666" }} />
            <InputBase placeholder="Search" sx={{ ml: 1, flex: 1 }} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
        </Box>
    );
};

export default SearchBar;
